import { TMasterSupportLanguage } from "@/api/entities/master-support-language.entity";
import { setHiddenSupportLanguageApi } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenSupportLanguageModalProps = {
  hiddenSupportLanguage?: TMasterSupportLanguage;
  setHiddenSupportLanguage: Dispatch<SetStateAction<TMasterSupportLanguage | undefined>>;
};

export const HiddenSupportLanguageModal: FC<THiddenSupportLanguageModalProps> = ({ hiddenSupportLanguage, setHiddenSupportLanguage }) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenSupportLanguage) return;
    try {
      await setHiddenSupportLanguageApi(toNumber(hiddenSupportLanguage.id), { isHidden: !hiddenSupportLanguage.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenSupportLanguage(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_SUPPORT_LANGUAGE] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenSupportLanguage?.isHidden ? "有効の確認" : "無効化の確認"}
      isOpen={!!hiddenSupportLanguage}
      onClose={() => setHiddenSupportLanguage(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenSupportLanguage?.isHidden ? "この行が有効になれますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
